import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const PageContainer = styled.div`
  ${tw`w-full max-w-full min-w-0 box-border px-4 py-8`}
`;

const ContentContainer = styled.div`
  ${tw`mx-auto w-full max-w-4xl`}
`;

const Header = styled.div`
  ${tw`flex justify-between items-center mb-6`}
`;

const ListContainer = styled.div`
  ${tw`space-y-4`}
`;

const CouponCardSkeleton = styled.div`
  ${tw`bg-white border border-border-default rounded-lg p-4`}
`;

const CardHeader = styled.div`
  ${tw`flex justify-between items-start mb-4`}
`;

const CardDetails = styled.div`
  ${tw`space-y-3`}
`;

const ActionRow = styled.div`
  ${tw`flex gap-2 mt-4 w-full max-w-full min-w-0 box-border`}
`;

const CouponsPageSkeleton: React.FC = () => {
  return (
    <PageContainer>
      <ContentContainer>
        <Header>
          <Skeleton width="120px" height="32px" />
          <Skeleton width="110px" height="40px" borderRadius="6px" />
        </Header>

        <ListContainer>
          {Array(4)
            .fill(0)
            .map((_, i) => (
              <CouponCardSkeleton key={i}>
                <CardHeader>
                  <div>
                    <Skeleton width="120px" height="24px" />
                    <div style={{ marginTop: '8px' }}>
                      <Skeleton width="180px" height="18px" />
                    </div>
                  </div>
                  <Skeleton width="70px" height="24px" borderRadius="12px" />
                </CardHeader>
                <CardDetails>
                  <Skeleton width="60%" height="16px" />
                  <Skeleton width="80%" height="16px" />
                  <Skeleton width="70%" height="16px" />
                  <Skeleton width="40%" height="16px" />
                </CardDetails>
                <ActionRow>
                  <Skeleton width="60px" height="32px" borderRadius="4px" />
                  <Skeleton width="70px" height="32px" borderRadius="4px" />
                </ActionRow>
              </CouponCardSkeleton>
            ))}
        </ListContainer>
      </ContentContainer>
    </PageContainer>
  );
};

export default CouponsPageSkeleton;
